export const ProcessNotFound = () => {
  return <div>Process not found</div>;
};
